import { LRUCache } from "./LRUCache";
/**
 * Wrapper around LRUCache that persists the cache to storage when the cache is updated
 */ export class PersistedLRUCache {
    /**
     * Get the value associated with the key, if it exists.
     * @param k Key to look up
     */ get(k) {
        return this.lruCache.get(k);
    }
    /**
     * Set the value associated with the key. This will also persist the cache to storage.
     * @param k Key to set
     * @param v Value to set
     */ set(k, v) {
        this.lruCache.set(k, v);
        this.persistCache();
    }
    /**
     * Load the cache from an array of key-value pairs.
     * @param dump Array of key-value pairs to load into the cache.
     */ load(dump) {
        this.lruCache.load(dump);
    }
    /**
     * Get all keys in the cache.
     */ keys() {
        return this.lruCache.keys();
    }
    /**
     * Delete item from the cache if it exists. This will also persist the cache to storage.
     * @param k Key to delete
     */ delete(k) {
        const isElementRemoved = this.lruCache.delete(k);
        this.persistCache();
        return isElementRemoved;
    }
    /**
     * Persist the cache to the storage
     */ persistCache() {
        const cacheItems = this.lruCache.dump();
        this.persistedStorage.setItem(this.storageKey, JSON.stringify(cacheItems));
    }
    /**
     * Dump the cache to an array of key-value pairs.
     */ dump() {
        return this.lruCache.dump();
    }
    constructor(persistedStorage, storageKey, max){
        this.persistedStorage = persistedStorage;
        this.storageKey = storageKey;
        this.lruCache = new LRUCache(max);
    }
}
